import React, { FC } from 'react';
import { numberFormat, Text } from '@mofid-securities/uikit';
import { TAssetType } from '@/services/apis/fund/types';

interface IAssetTypeRowCardProps {
  type: TAssetType;
}

export const AssetTypeRowCard: FC<IAssetTypeRowCardProps> = ({
  type: { count, title, value },
}) => {
  return (
    <div className="flex items-center justify-between">
      <div className="flex justify-center gap-x-1 font-medium text-gray-filled-tertiary-enabled">
        <Text size="xs">بخش خرید {title}</Text>
        <Text size="xxs">({numberFormat(count)} واحد)</Text>
      </div>
      <div className="flex items-center gap-x-1 text-gray-filled-primary-enabled">
        <Text size="sm" weight="medium">
          {numberFormat(value)}
        </Text>
        <Text size="xs">ریال</Text>
      </div>
    </div>
  );
};
